export enum ContentType {
  MOVIE = 'movie',
  TV_SERIES = 'tvseries',
  TV_SEASON = 'tvseason',
  TV_EPISODE = 'tvepisode',
  TRAILER = 'trailer',
  SHORT_VIDEO = 'shortvideo',
  PROMO = 'promo',
  WEB_SERIES = 'webseries',
  WEB_SEASON = 'webseason',
  WEB_EPISODE = 'webepisode',
  CHANNEL = 'channel',
  LIVE_CHANNEL = 'livechannel',
  LIVE_EVENT = 'liveevent',
  EVENT = 'event',
  VOD_EVENT = '(vod)event',
  VOD_EVENT2 = 'vod event',
}
